import makeRequestUrl from './url.js';

module.exports = () => {
    const domain = '//shop-api.haoyintechnology.com/api';
    const blackCardDomain = '//m.haoyintechnology.com';
    const fanxianDomain = '//fanxian-api.haoyintechnology.com';
    const lbsDomain = '//lbs.chuxingyouhui.com/api';

    const marketingDomain = '//market.chuxingyouhui.com/promo-bargain-api';
    const privilegeApiDomain = `//privilege-api.black-unique.com`;
    const jsonConfigDomain = '//h5.chuxingyouhui.com/yunying/config/json';
    const privilegeDomain = `//privilege-api.black-unique.com`;
    const vipMemberDomain = `//vip-member.chuxingyouhui.com`;
    const orderDomain = '//union-order-api.haoyintechnology.com';
    const annualDomain = `//annual-summary-api.chuxingyouhui.com`;
    const adsDomain = `//advertise-api.black-unique.com`;

    const api = makeRequestUrl({
        blackCardDomain,
        domain,
        lbsDomain,
        jsonConfigDomain,
        marketingDomain,
        fanxianDomain,
        privilegeApiDomain,
        privilegeDomain,
        vipMemberDomain,
        adsDomain,
    });

    exports.domain = domain;
    exports.api = api;
    exports.blackCardDomain = blackCardDomain;
    exports.fanxianDomain = fanxianDomain;
    exports.lbsDomain = lbsDomain;
    exports.marketingDomain = marketingDomain;
    exports.privilegeApiDomain = privilegeApiDomain;
    exports.privilegeDomain = privilegeDomain;
    exports.vipMemberDomain = vipMemberDomain;
    exports.orderDomain = orderDomain;

    exports.annualDomain = annualDomain;
    exports.adsDomain = adsDomain;
    // 环境类型标识
    exports.envType = 'prod';
    exports.envPrefix = '';

    // app下载链接
    exports.appDownloadUrl = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.black.unique';

    return exports;
};
